import { render, staticRenderFns } from "./abogados.vue?vue&type=template&id=34c2dcc2"
import script from "./abogados.vue?vue&type=script&lang=js"
export * from "./abogados.vue?vue&type=script&lang=js"
import style0 from "./abogados.vue?vue&type=style&index=0&id=34c2dcc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports